<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="300"
      size="mini"
      border
      round
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-danger group-title">
            {{ $l('INDEX.tips_title_add_color_qty') || '增加多个颜色' }}
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row, $rowIndex }">
        <vxe-button
          v-if="tableDataLength === $rowIndex + 1"
          type="text"
          icon="vxe-icon--plus"
          @click="add(-1)"
          >{{ $l('INDEX.btn_add') || '增加' }}
        </vxe-button>
        <vxe-button
          type="text"
          icon="vxe-icon--minus"
          v-if="$rowIndex !== 0"
          @click="del(row)"
          >{{ $l('INDEX.btn_delete') || '删除' }}
        </vxe-button>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  mixins: [],
  components: {},
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableColumns: tableColumns(this),
      delFlag: false,
      validRules: {
        orderGoodsColor: [
          {
            required: true,
            message: '产品颜色必须填写'
          }
        ],
        orderGoodsColorEn: [
          {
            required: true,
            message: '英文颜色必须填写'
          }
        ],
        qty: [
          {
            type: 'number',
            required: true,
            message: '请输入数量'
          }
        ],
        price: [
          {
            type: 'number',
            required: true,
            message: '请输入价格'
          }
        ],
        salePrice: [
          {
            type: 'number',
            required: true,
            message: '请输入市场价格'
          }
        ]
      }
    }
  },
  computed: {
    tableRef() {
      return this.$refs.vxeGrid
    },
    tableDataLength() {
      const { tableData } = this.tableRef.getTableData()
      return tableData.length
    }
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: '#ffffff'
      }
    },
    add(row) {
      this.tableRef.insertAt({}, row)
    },
    del(row) {
      this.tableRef.remove(row)
    },
    async getTableData() {
      const result = await this.validAllEvent()
      if (!result) return result
      const { tableData } = this.$refs.vxeGrid.getTableData()

      return tableData.map((row) => {
        var identifyGoodsJson = []
        if (row.Item) {
          identifyGoodsJson.push({
            identifyNo: row.Item,
            identifyCodeType: 'Item',
            identifyCodeTypeText: 'Item'
          })
        }
        if (row.UPC) {
          identifyGoodsJson.push({
            identifyNo: row.UPC,
            identifyCodeType: 'UPC',
            identifyCodeTypeText: 'UPC'
          })
        }
        const identifyGoodsNo = identifyGoodsJson
          .map((i) => i.identifyCodeTypeText + ':' + i.identifyNo)
          .join()
        return {
          orderGoodsColor: row.orderGoodsColor,
          orderGoodsColorEn: row.orderGoodsColorEn,
          qty: row.qty,
          price: row.price,
          salePrice: row.salePrice,
          identifyGoodsNo: identifyGoodsNo,
          identifyGoodsJson: JSON.stringify(identifyGoodsJson)
        }
      })
    },
    async validAllEvent() {
      const $table = this.$refs.vxeGrid
      const errMap = await $table.validate(true).catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.order-goods-tbale .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
